import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

/**
 * Shared page hero used on Services / Work / About / Contact.
 * Editorial-minimal, consistent with the Home hero pacing.
 */
export default function PageHero({
    kicker,
    title,
    accent,
    tagline,
    meta,
    "data-testid": testId,
}) {
    return (
        <section
            data-testid={testId || "page-hero"}
            className="relative pt-32 pb-16 lg:pt-40 lg:pb-24 overflow-hidden"
        >
            <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
                <motion.div
                    initial={{ opacity: 0, y: 16 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.7, ease }}
                    className="flex flex-wrap items-center justify-between gap-4 mb-10 text-xs uppercase tracking-[0.22em] font-bold text-black/55"
                >
                    <span>{kicker}</span>
                    {meta && <span>{meta}</span>}
                </motion.div>

                <div className="grid grid-cols-12 gap-y-8 lg:gap-x-10 items-end">
                    <motion.h1
                        data-testid="page-hero-title"
                        initial={{ opacity: 0, y: 40 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1, ease }}
                        className="col-span-12 lg:col-span-8 font-display font-black uppercase leading-[0.88] tracking-[-0.03em] text-6xl sm:text-7xl lg:text-[9.5vw]"
                    >
                        {title}
                        {accent && (
                            <>
                                <br />
                                <span className="outline-text">
                                    {accent}
                                    <span className="text-olive">·</span>
                                </span>
                            </>
                        )}
                    </motion.h1>

                    {tagline && (
                        <motion.p
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.9, ease, delay: 0.2 }}
                            className="col-span-12 lg:col-span-4 font-serif italic text-xl lg:text-2xl text-black/65 max-w-md lg:pb-4"
                        >
                            {tagline}
                        </motion.p>
                    )}
                </div>
            </div>
        </section>
    );
}
